import { useMemo, useState } from 'react';
import type { CatalogSkin } from '../types';
import SkinIcon from './SkinIcon';

export default function SkinPicker({
  skins,
  selectedKeys,
  onToggle,
}: {
  skins: CatalogSkin[];
  selectedKeys: Set<string>;
  onToggle: (key: string) => void;
}) {
  const [query, setQuery] = useState('');

  const filtered = useMemo(() => {
    if (!query.trim()) return skins;
    const q = query.trim().toLowerCase();
    return skins.filter((s) => `${s.hero} ${s.name}`.toLowerCase().includes(q));
  }, [skins, query]);

  return (
    <div>
      <input
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Поиск по герою или скину..."
        className="mb-3 w-full rounded-xl border border-mlbb-border bg-mlbb-card px-3 py-2 text-sm text-white placeholder:text-white/40 focus:outline-none focus:ring-1 focus:ring-mlbb-accent-from"
      />
      {filtered.length === 0 ? (
        <div className="py-8 text-center text-sm text-white/40">Ничего не найдено</div>
      ) : (
        <div className="grid grid-cols-4 gap-3 sm:grid-cols-5">
          {filtered.map((skin) => (
            <div key={skin.key} className="flex flex-col items-center gap-1">
              <SkinIcon
                icon={skin.icon}
                hero={skin.hero}
                tier={skin.tier}
                size={64}
                selected={selectedKeys.has(skin.key)}
                onClick={() => onToggle(skin.key)}
              />
              <div className="w-full truncate text-center text-[10px] text-white/60" title={`${skin.hero} — ${skin.name}`}>
                {skin.hero}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
